import { Link, useInRouterContext } from "react-router-dom";
import { useInboxUnread } from "./unread.js";

/**
 * Home's pointer at the Inbox.
 *
 * A count and a way in, and deliberately not a preview of the newest message.
 * The panel this replaced drew a second copy of the inbox on Home — its own
 * request, its own read state, its own name for the feature — which is the
 * parallel system this rollout exists to remove. What Home owes somebody is
 * "there is something waiting for you"; the conversation itself is one click
 * away and has a screen of its own now.
 *
 * Nothing at all when nothing is unread, and nothing while the count is still
 * loading: an empty panel that appears and then fills is worse than one that
 * appears when it has something to say.
 */
export function InboxSummary() {
  const { unread } = useInboxUnread();
  const inRouter = useInRouterContext();
  const count = unread?.messages ?? 0;
  if (count === 0) return null;

  const conversations = unread?.conversations ?? 0;
  const label = `${count} unread ${count === 1 ? "message" : "messages"}`;

  return (
    <section aria-labelledby="inbox-summary-heading">
      <div className="spread-center">
        <h2 id="inbox-summary-heading">Inbox</h2>
        <span className="tag warn" aria-label={label}>
          {count} unread
        </span>
      </div>
      <div className="panel">
        <strong>You have {label}</strong>
        <div className="small muted">
          {conversations === 1
            ? "In one conversation."
            : `Across ${conversations} conversations.`}
        </div>
        <div className="student-home-section-link">
          {inRouter ? <Link to="/inbox">Open Inbox</Link> : <a href="/inbox">Open Inbox</a>}
        </div>
      </div>
    </section>
  );
}
